import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupSubstract2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-substract-2"><path d="M8.75 8.75H2.75V21.25H15.25V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 8.75V10V13V15.25H11H14H15.25M8.75 5V2.75H11M19 2.75H21.25V5M14 2.75H16M21.25 8V10M21.25 13V15.25H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBooleanGroupSubstract2;
